module.exports = __webpack_public_path__ + "img/06-TUTA-BAIA-U-STAMPE-LINO-UNITI-LINO4.fb364a6b.jpg";